module.exports = __webpack_public_path__ + "img/icon_customer_active.ed1d9e65.svg";